import HexMap from "../HexMap";
import SyDialog from "../SyDialog";
import "./styles.css";

const LocationDialog = ({ open, value, addressText, onClose, onSave }) => (
  <SyDialog
    open={open}
    onClose={onClose}
    size="lg"
    className="pin-location-modal"
    title="Pin your location"
    subtitle="Search for an address, or tap the map to move the pin."
  >
    {open && (
      <HexMap
        mapProps={{ ...value, addressText }}
        modal={true}
        onClose={onClose}
        onSave={onSave}
      />
    )}
  </SyDialog>
);

export default LocationDialog;
